import { UNAUTHORIZED } from '~/config/constants';
import { storeApiValidationErrors } from '~/stores/redux/common/apiValidationErrorSlice';
import { alertSwal } from '~/utils/helpers';
import { requestFinished } from '~/stores/redux/common/loadingSlice';
import * as auth from './auth/auth.service';

export const handleThunkException = (error, dispatch, navigate = null) => {
    if (error.message === UNAUTHORIZED) {
        auth.logoutFE(dispatch, navigate);
    }

    if (error.status === 422) {
        const errorBags = error.data.errors;
        let errors = [];
        for (const key in errorBags) {
            errorBags[key].forEach((item) => errors.push(item));
        }

        alertSwal('error', 'There are errors in your form. Please fix it and try again!');

        dispatch(storeApiValidationErrors(errors));
        dispatch(requestFinished());
    }
};
